import HomeBranding from '../pages/HomeBranding'
import NotFound from '../pages/elements/404'
import Imprint from "../pages/content/Imprint"
import DataProtection from "../pages/content/DataProtection"
import Gallery from '../pages/Gallery.vue';
import SingleLibary from '../pages/SingleLibary.vue';
import Shop from '../pages/Shop.vue';
import ShopProduct from '../pages/ShopProduct.vue';

export const routes = [
    {
        path:'/',
        name: 'HomeBranding',
        component: HomeBranding
    },
    {
        path:'/gallery',
        name: 'Gallery',
        component: Gallery
    },
    {
        path:'/shop',
        name: 'Shop',
        component: Shop
    },
    {
        path: '/shop/:package',
        name: 'ShopProduct',
        component: ShopProduct
    },
    {
        path: '/libary-view/:id',
        name: 'LibaryView',
        component: SingleLibary
    },
    {
        path:'/impressum',
        name: 'Imprint',
        component: Imprint
    },
    {
        path:'/datenschutz',
        name: 'DataProtection',
        component: DataProtection
    },
    {
        path:'*',
        name: 'NotFound',
        component: NotFound
    },
];